"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaItemCard = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var MediaMenu_1 = require("../MediaMenu");
var MediaContext_1 = require("../MediaContext");
function MediaItemCard(_a) {
    var mediaItem = _a.mediaItem, onSelect = _a.onSelect;
    var mediaContext = (0, MediaContext_1.useMediaContext)();
    var cursor = 'initial';
    var opacity = 1;
    if (onSelect) {
        cursor = 'pointer';
    }
    if (mediaContext.filter && mediaItem.filter_state === false) {
        cursor = 'not-allowed';
        opacity = 0.5;
    }
    return (React.createElement(react_1.Card, { backgroundColor: "gray.300", boxShadow: "lg", display: "flex", flexDirection: "column", justifyContent: "space-between", "aria-label": mediaItem.filename, role: "listitem", cursor: cursor, opacity: opacity, onClick: function () { return onSelect === null || onSelect === void 0 ? void 0 : onSelect(mediaItem); }, "data-feature-id": onSelect ? "media_manager_item_select" : null },
        React.createElement(react_1.Box, { minH: "125px" },
            React.createElement(react_1.Image, { w: "172px", maxH: "125px", src: mediaItem.standard, objectFit: "contain" })),
        React.createElement(react_1.CardBody, { pl: 1, pr: 1, pb: 1 },
            React.createElement(react_1.Flex, { justifyContent: "center", alignItems: "center", backgroundColor: "white", h: "25px" },
                React.createElement(react_1.Text, { noOfLines: 1, maxW: "162px" }, mediaItem.filename)),
            React.createElement(react_1.Flex, { justifyContent: "right", alignItems: "right", onClick: function (e) { return e.stopPropagation(); } },
                React.createElement(MediaMenu_1.MediaMenu, { mediaItem: mediaItem })))));
}
exports.MediaItemCard = MediaItemCard;
